import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { cn } from '@/lib/utils';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { Separator } from '../separator';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <>
    <AccordionPrimitive.Item
      ref={ref}
      className={cn('py-6 md:py-8', className)}
      {...props}
    />
    <Separator className="last-of-type:hidden bg-light-grey-300" />
  </>
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header
    className={cn(
      'flex justify-between text-base md:text-lg lg:text-xl text-black  font-nunito700',
      className
    )}
  >
    {children}
    <AccordionPrimitive.Trigger
      ref={ref}
      className="transition-all cursor-pointer [&[data-state=open]_svg]:rotate-180"
      {...props}
    >
      <div className="size-6 md:size-8 bg-black rounded-[3px] shrink-0 flex items-center justify-center">
        <ChevronDownIcon className="size-[18px] md:size-6 transition-transform duration-300 text-white" />
      </div>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn(className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
